import { Bag, removeProduct } from "@repo/apis/bag";
import { setBagCookies } from "../utils/bag-cookies";
import { handleApiInteractionError } from "../utils/handle-api-interaction-error";
import { BagSdkMethod } from "../utils/method-initialiser";

type PublicRemoveProductMethod = (params: {
  bagItemId: string;
}) => Promise<Bag>;
type RemoveProductMethod = BagSdkMethod<PublicRemoveProductMethod>;

export const removeProductInitialiser: RemoveProductMethod =
  ({
    chameleonRequestInstance,
    store,
    lang,
    getAuthHeaderPredicate,
    state,
    country,
  }) =>
  async ({ bagItemId }) => {
    const authHeader = await getAuthHeaderPredicate();
    const bag = state.getBag();
    const bagSessionToken = state.getBagSessionToken();
    const bagExpansions = state.getBagExpansions();

    if (!bag) {
      throw new Error("Failed to remove product. The bag does not exist");
    }

    const bagId = bag.id;

    try {
      const removeProductResult = await removeProduct({
        chameleonRequestInstance,
        bagItemId,
        store,
        lang,
        authHeader,
        asosBagSessionToken: bagSessionToken as string,
        bagId,
        expand: bagExpansions,
      });

      state.setBag(removeProductResult.data.bag);
      state.setBagSessionToken(removeProductResult.bagSessionToken);

      setBagCookies(
        { store, country },
        {
          bagId: removeProductResult.data.bag.id,
          bagOrigin: removeProductResult.data.bag.origin,
          sessionToken: removeProductResult.bagSessionToken,
        },
      );

      return removeProductResult.data.bag;
    } catch (error: unknown) {
      return handleApiInteractionError(error);
    }
  };
